
import { defineComponent, onMounted, PropType, ref } from "vue";
import { ImageFrame } from "./EditDownload.vue";
import { useLoading } from "@/lib/loading";

export default defineComponent({
  name: "EditDownloadSelectOutputSelect",
  props: {
    images: { type: Object as PropType<ImageFrame[]> },
    selectFrames: { type: Object as PropType<number[]> },
  },
  setup(props, context) {
    const selectFramesInner = ref(props.selectFrames);
    const loading = useLoading();

    // コマの選択状態の更新
    const updateValue = (e: InputEvent) => {
      const elm = e.target as HTMLInputElement;
      const index = Number.parseInt(elm.value);
      let xs = selectFramesInner.value;
      if (xs === undefined) return;

      if (elm.checked) {
        // ダウンロード対象とする
        xs.push(index);
      } else {
        // ダウンロード対象から外す
        xs = xs.filter((x) => x != index);
      }
      selectFramesInner.value = xs;
      context.emit("update:selectFrames", selectFramesInner.value);
    };

    // サムネイルを1コマずつ並べて表示する
    const editedImgs = ref<HTMLElement[]>([]);
    onMounted(async () => {
      await loading.loadWith(async () => {
        if (props.images === undefined) return;
        editedImgs.value = props.images.map((x) => x.template);
      });
    });
    return {
      updateValue,
      editedImgs,
    };
  },
});
